import type { FeatureServicesTabsContent } from '@/core/types';

import { FeatureServicesTabs } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: FeatureServicesTabsContent;
  className?: string;
}) {
  return (
    <FeatureServicesTabs
      title={content.title}
      description={content.description}
      items={content.items}
      buttons={content.buttons}
      className={className}
    />
  );
}
